import { render, staticRenderFns } from "./evaluacion-seleccion-proveedores2.10.1-1.vue?vue&type=template&id=60d57aff&scoped=true&"
import script from "./evaluacion-seleccion-proveedores2.10.1-1.vue?vue&type=script&lang=js&"
export * from "./evaluacion-seleccion-proveedores2.10.1-1.vue?vue&type=script&lang=js&"
import style0 from "./evaluacion-seleccion-proveedores2.10.1-1.vue?vue&type=style&index=0&id=60d57aff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60d57aff",
  null
  
)

export default component.exports